import { ManagementModal } from "app/pages/sales-intelligence/common-components/modals/ManagementModal/ManagementModal";
import { allTrackers } from "app/services/track/track";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import { useExportDisabledModalProps } from "../../hooks/useExportDisabledModalProps";
import { MANAGEMENT_CANCEL_TEXT } from "app/pages/sales-intelligence/pages/management/translations/managementKeys";
import { CUSTOM_DETAILS_STYLES, CUSTOM_MODAL_STYLES } from "../../styles/styles";
import integrationTrackingService from "app/pages/sales-intelligence/services/tracking/integrationTrackingService";
import { translate } from "app/filters/i18nFilter";
import { getCrmName } from "app/pages/sales-intelligence/utils/crm";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

export const ExportToggleModal = () => {
    const { integrationName } = getIntegrationNameFromUrl();

    const { setModalState, onConfirm, isOpen, isDisabledExport, toggleName } = useExportDisabledModalProps(
        integrationName as Integration,
    );

    const onClose = () => {
        setModalState(false);

        allTrackers.dispatchTrackEvent(
            `${integrationName} integration`,
            `cancel`,
            `export/${toggleName}/disable export`,
        );
    };

    const handleConfirm = () => {
        allTrackers.dispatchTrackEvent(
            `${integrationName} integration`,
            `disable`,
            `export/${toggleName}/disable export`,
        );

        setModalState(false);
        onConfirm(false);
    };

    const handleCheckbox = (value: boolean) => {
        if (value) {
            integrationTrackingService.trackDisabledIntegrationModal(integrationName as Integration, toggleName || "");
        }

        sessionStorage.setItem("isDisabledIntegrationModal", value ? "true" : "");
    };

    return (
        <ManagementModal
            customStyles={CUSTOM_MODAL_STYLES}
            customDetailsStyles={CUSTOM_DETAILS_STYLES}
            isOpen={!isDisabledExport ? isOpen : null}
            onConfirm={handleConfirm}
            onClose={onClose}
            title={translate("si.management.manage-integration.toggle.modal.title", {
                integrationName: getCrmName(integrationName as Integration),
            })}
            details={translate("si.management.manage-integration.toggle.modal.details", {
                integrationName: getCrmName(integrationName as Integration),
                toggleName: toggleName || undefined,
            })}
            confirmBtnText={translate("si.management.manage-integration.toggle.modal.confirm")}
            confirmBtnType="warning"
            cancelBtnType="flatDark"
            cancelBtnText={translate(MANAGEMENT_CANCEL_TEXT)}
            checkboxText={translate("si.management.manage-integration.toggle.modal.checkbox")}
            onCheckboxClick={handleCheckbox}
        />
    );
};
